module.exports = __webpack_public_path__ + "img/gos-uslugi.ef431d29.svg";